<template>
<div class="modal" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header" :class="headerStyle" :role="headerRole">
        <slot name="header"/>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <slot/>
      </div>
      <div class="modal-footer">
        <slot name="footer"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import $ from 'jquery'
export default {
  props: ['headerStyle', 'headerRole'],
  methods: {
    showModal () {
      var target = $('#' + this.$el.id)
      if (target.length) {
        target.modal()
      }
    },
    hideModal () {
      var target = $('#' + this.$el.id)
      if (target.length) {
        target.modal('hide')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// HeaderModal.vue?0862d5cc